angular.module('impactx.product').controller('ProductEditCtrl', [
    '$scope',
    '$routeParams',
    'dataGen',
    '$mdToast',
    'BackService',
    '$mdDialog',
    'CommentOnSaveService',
    'ToastService',
    '$config',
    'ConfirmationService',
    'TranslationService',
    'ToolbarService',
    ProductEditCtrl
]);

function ProductEditCtrl($scope, $routeParams, dataGen, $mdToast, BackService, $mdDialog, CommentOnSaveService, ToastService, $config, ConfirmationService,
                         TranslationService, ToolbarService) {
    var ctrl = this;
    dataGen.getData($scope, {
        id: $routeParams.id,
        catId: $routeParams.catId,
        changewithoutcheckout: !!$routeParams.changewithoutcheckout
    }, "/product/checkout/get").then(function () {
        if ($scope.data.changeProductGroup) {
            $mdDialog.show({
                controller: "ChangeCatalogCtrl",
                controllerAs: "changeCatalogCtrl",
                templateUrl: "modules/product/templates/changecatalog.tmpl.html",
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                locals: {
                    data: $scope.data,
                    trns: $scope.trns
                }
            }).then(function(data) {
                $scope.data = data;
                defineButtons();
            }, function () {
                if ($scope.data.changeProductGroupNeeded) {
                    var dataObj = {
                        proId: $scope.data.id,
                        changewithoutcheckout: $routeParams.changewithoutcheckout
                    };
                    var tempScope = {};
                    dataGen.postAsForm(tempScope, dataObj, "/product/checkout/undocheckout").then(function () {
                        BackService.back();
                    });

                }
                else {
                    defineButtons();
                }
            });
        }
        else {
            defineButtons();
        }
    });

    this.saveAndRelease = function (event) {
        return ctrl.save(event, true);
    };

    this.save = function (event, release) {
        var currentDate = new Date();
        var showWarning = false;
        var warningPriceGroups = [];
        for (var i = 0; i < $scope.data.priceConfiguration.priceGroups.length; i++) {
            var priceGroup = $scope.data.priceConfiguration.priceGroups[i];
            var hasActiveOrFuturePriceForPriceGroup = false;
            var hasPriceForPriceGroup = false;
            for (var j = 0; j < priceGroup.priceLists.length; j++) {
                var priceList = priceGroup.priceLists[j];
                if (!priceList.deleted) {
                    hasPriceForPriceGroup = true;
                    if (impactX.isDefined(priceList, 'startDate.dateValue') && impactX.isDefined(priceList, 'endDate.dateValue') && (
                        priceList.startDate.dateValue > currentDate || priceList.endDate.dateValue > currentDate ||
                        ctrl.checkSameDay(currentDate, priceList.startDate.dateValue) || ctrl.checkSameDay(currentDate, priceList.endDate.dateValue)
                        )) {
                        hasActiveOrFuturePriceForPriceGroup = true;
                    }
                }
            }
            if (hasPriceForPriceGroup && !hasActiveOrFuturePriceForPriceGroup) {
                showWarning = true;
                warningPriceGroups.push(priceGroup.name);
            }
        }
        if (showWarning) {
            var priceNotValidString = $scope.trns.priceNotValidStringSingular;
            if (warningPriceGroups.length > 1) {
                priceNotValidString = $scope.trns.priceNotValidStringPlural;
            }
            var replaceString = "";
            for (var k = 0; k < warningPriceGroups.length; k++) {
                if (k > 0) {
                    replaceString = replaceString + ", " + warningPriceGroups[k];
                }
                else {
                    replaceString = warningPriceGroups[k];
                }
            }
            priceNotValidString = priceNotValidString.replace("^0", replaceString);
            ConfirmationService.showConfirmationDialog(release ? ctrl.saveFinalAndRelease : ctrl.saveFinal, event, priceNotValidString,
                TranslationService.get("save"), TranslationService.get("abort"));
        }
        else {
            if (release) {
                return ctrl.saveFinalAndRelease();
            }
            else {
                return ctrl.saveFinal();
            }
        }
    };

    this.saveFinal = function () {
        var dataObj = {
            pro: $scope.data
        };
        var tempScope = {};
        return dataGen.postAsForm(tempScope, dataObj, "/product/checkout/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent(tempScope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.saveFinalAndRelease = function () {
        var dataObj = {
            pro: $scope.data
        };
        var tempScope = {};
        return dataGen.postAsForm(tempScope, dataObj, "/product/checkout/release").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent(tempScope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.checkSameDay = function (date1, date2) {
        return date1 instanceof Date && date2 instanceof Date &&
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
    };

    this.addPriceList = function (event, priceGroup) {
        $mdDialog.show({
            controller: "AddPriceListCtrl",
            controllerAs: "priceListCtrl",
            templateUrl: "modules/product/templates/addpricelist.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                data: {
                    proId: $scope.data.id,
                    catId: $scope.data.catId,
                    matchCode: priceGroup.matchCode,
                    changewithoutcheckout: !!$routeParams.changewithoutcheckout
                },
                priceGroup: priceGroup,
                trns: $scope.trns,
                orderUnit: $scope.data.orderUnit.selected ? $scope.data.orderUnit.selected.value : "",
                allowFracAmounts: $scope.data.additionalMainData.fracAmount.value
            }
        });
    };

    this.addPriceRule = function (event, priceGroup) {
        dataGen.getData({}, {catId: $routeParams.catId, targetMatchCode: priceGroup.matchCode}, "/product/pricerule/new").then(function (response) {
            if (response && response.data) {
                priceGroup.priceRule = response.data;
            }
        });
    };

    this.canAddPriceRule = function (priceGroup) {
        return (!priceGroup.priceRule || priceGroup.priceRule.deleted) && !(priceGroup.fixedPrice && priceGroup.fixedPrice.value) &&
            priceGroup.priceLists.filter(function (entry) {
                return !entry.deleted
            }).length === 0;
    }

    this.recalcPriceRule = function (priceRule) {
        var priceLists = [];
        if (priceRule) {
            if (priceRule.source.selected) {
                var currency = impactX.isDefined(priceRule, 'currency.selected.id');
                if (currency) {
                    var sourceGroup = $scope.data.priceConfiguration.priceGroups.filter(function (entry) {
                        return entry.matchCode === priceRule.source.selected.id;
                    })[0]; // there should only be one, should always be found

                    angular.forEach(sourceGroup.priceLists, function (priceList) {
                        if (!priceList.deleted) {
                            var listCopy = JSON.parse(JSON.stringify(priceList));
                            if (listCopy.currencyValue === currency) {
                                angular.forEach(listCopy.priceListItems, function (pli) {
                                    pli.value.value = pli.value.value * (priceRule.factor.value/100 || 0) + (priceRule.offset.value || 0);
                                });
                            }
                            else {
                                listCopy.priceListItems = [];
                            }
                            priceLists.push(listCopy);
                        }
                    });
                }
            }
        }
        return priceLists;
    }

    this.toggleFixed = function (event, priceGroup) {
        if (priceGroup && priceGroup.fixedPrice.value) {
            if (priceGroup.priceRule && !priceGroup.priceRule.deleted) {
                priceGroup.priceRule.deleted = true;
                angular.forEach(priceGroup.priceLists, function (priceList) {
                    priceList.deleted = true;
                });
                this.addPriceList(event, priceGroup);
            }
        }
    }

    var denyInternal = function () {
        var dataObj = {
            proId: $scope.data.id
        };
        var tempScope = {};
        return dataGen.postAsForm(tempScope, dataObj, "/product/checkout/deny").then(function () {
            BackService.back();
            ToastService.openStandardToast(tempScope.trns.saveSuccess);
        });
    };

    this.denyProductFinal = function (event) {
        CommentOnSaveService.showCommentOnSaveDialog(denyInternal, event, $scope.trns.comment,
            $scope.trns.save, $scope.trns.abort, $scope.trns.comment, $scope.data.comments.externalComments);
    };

    this.denyProduct = function (event) {
        var proIds = [];
        proIds.push($scope.data.id)
        var dataObj = {
            proIds: proIds
        };
        var tempScopeOuter = {};
        return dataGen.postAsForm(tempScopeOuter, dataObj, "/product/checkout/denywarning").then(function () {
            if (tempScopeOuter.data.referencingProducts.length > 0) {
                $mdDialog.show({
                    controller: "DenyWarningCtrl",
                    controllerAs: "denyWarningCtrl",
                    templateUrl: "modules/catalog/templates/deny-warning.tmpl.html",
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        trns: tempScopeOuter.trns,
                        referencingProducts: tempScopeOuter.data.referencingProducts
                    }
                })
                    .then(function () {
                        ctrl.denyProductFinal(event);
                    }, function () {
                    });
            }
            else {
                ctrl.denyProductFinal(event);
            }
        });
    };

    this.undoCheckoutProduct = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.undoCheckoutProductFinal, event, $scope.trns.undoCheckoutConfirm, TranslationService.get("ok"),
            $scope.trns.abort);
    };

    this.undoCheckoutProductFinal = function () {
        var dataObj = {
            proId: $scope.data.id,
            changewithoutcheckout: $routeParams.changewithoutcheckout
        };
        var tempScope = {};
        return dataGen.postAsForm(tempScope, dataObj, "/product/checkout/undocheckout").then(function () {
            BackService.back();
            ToastService.openStandardToast(tempScope.trns.saveSuccess);
        });
    };

    this.showMainDataDialog = function (event) {
        $mdDialog.show({
            controller: "AdditionalMainProductDataCtrl",
            controllerAs: "additionalMainProductDataCtrl",
            templateUrl: "modules/product/templates/mainproductdata.additional.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                data: $scope.data,
                headerLabel: $scope.trns.additionalMainData,
                confirmLabel: $scope.trns.confirm,
                abortLabel: $scope.trns.abort,
                noSelectedItemMessage: $scope.trns.noSelectedItemMessage,
                freeSelectionMessage: $scope.trns.freeSelectionMessageManufacturer,
                energieLabelHeaderLabel: $scope.trns.euEnergielabel,
                energieLabelMMD: $scope.trns.euEnergieLabelMMD,
                energieLabelDescriptionMMD: $scope.trns.euEnergieLabelDescriptionMMD
            }
        });
    };

    this.showContactDialog = function (event) {
        $mdDialog.show({
            controller: "ProductContactsCtrl",
            controllerAs: "productContactsCtrl",
            templateUrl: "modules/product/templates/product.contacts.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                data: $scope.data,
                headerLabel: $scope.trns.contactRelation,
                confirmLabel: $scope.trns.confirm,
                abortLabel: $scope.trns.abort,
                noSelectedItemMessage: $scope.trns.noSelectedItemMessage,
                requiredLabel: $scope.trns.required
            }
        });
    };

    this.showAttributesDialog = function (event) {
        $mdDialog.show({
            controller: "ProductAttributesCtrl",
            controllerAs: "productAttributesCtrl",
            templateUrl: "modules/product/templates/product.attributes.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                data: $scope.data,
                headerLabel: $scope.trns.attributes,
                confirmLabel: $scope.trns.confirm,
                abortLabel: $scope.trns.abort,
                requiredLabel: $scope.trns.required,
                noSelectedItemMessage: $scope.trns.noSelectedItemMessage,
                trns: $scope.trns,
                freeSelectionMessage: $scope.trns.freeSelectionMessageAttribute
            }
        });
    };

    this.showPrgDialog = function (event) {
        $mdDialog.show({
            controller: "ProductPrgCtrl",
            controllerAs: "ctrl",
            templateUrl: "modules/product/templates/product.prg.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                currentPrg: $scope.data.selectedPrg,
                catId: $scope.data.catId,
                vcatId: 0
            }
        }).then(function (response) {
            $scope.data.selectedPrg = response;
        });
    };

    this.getManufacturerCompanies = function (searchText) {
        return dataGen.getData({}, {searchText: searchText}, "/product/manufacturer/popup", null, true).then(function (data) {
            return data.data.entries;
        });
    };

    this.manufacturerSearchTextChanged = function (selected, searchText) {
        if (!$scope.data.manufacturerCompany.freeSelection) {
            $scope.data.manufacturerCompany.freeSelection = {value: null};
        }
        if (!selected) {
            $scope.data.manufacturerCompany.freeSelection.value = searchText;
        }
        else {
            $scope.data.manufacturerCompany.freeSelection.value = null;
        }
    };

    this.manufacturerSelect = function (selected, baseObject, searchText) {
        if (!$scope.data.manufacturerCompany.freeSelection) {
            $scope.data.manufacturerCompany.freeSelection = {value: null};
        }
        if (!selected) {
            $scope.data.manufacturerCompany.freeSelection.value = searchText;
        }
        else {
            $scope.data.manufacturerCompany.freeSelection.value = null;
        }
    };

    $scope.tinymceOptions = $config.tinymceOptions;

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                condition: canSave,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.release,
                action: ctrl.saveAndRelease,
                type: 'validation',
                condition: canRelease,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.denyProduct,
                type: 'dialogaction',
                condition: canDeny
            },
            {
                label: $scope.trns.additionalMainData,
                action: ctrl.showMainDataDialog,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.attributes,
                action: ctrl.showAttributesDialog,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.editPrg,
                action: ctrl.showPrgDialog,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.undoCheckout,
                action: ctrl.undoCheckoutProduct,
                type: 'dialogaction',
                condition: canEdit
            }
        ];
        if($routeParams.changewithoutcheckout) ToolbarService.hideBackButton();
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canSave() {
        return isEditable() && !$routeParams.changewithoutcheckout;
    }

    function canDeny() {
        return canEdit() && !$scope.data.isDenied && !$routeParams.changewithoutcheckout;
    }

    function canRelease() {
        return canEdit() && !$scope.data.isDenied && $routeParams.changewithoutcheckout;
    }

    function canEdit() {
        return isEditable() && $scope.data.id > 0;
    }

    ctrl.getPanelFallbackImage = function () {
        return $scope.data ? $scope.data.panelFallbackImage : undefined;
    }
}